export { RecipeTips } from './recipe-tips';
export type { RecipeTipsProps } from './recipe-tips';
